import { Box, FormGroup, Paper, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ROUTES } from "router/types";
import {
  addFilters,
  clearFilters,
  updateFilters,
} from "store/table/table.slice";
import { AppState } from "store/types";
import CrossIcon from "assets/Icons/replenishment/CrossIcon.svg";
import Select from "components/Select";
import Button from "components/Button";
import I18nKey from "translations/I18nKey";
import { useIntl } from "react-intl";
import { addSelectedSellers, removeAllSellers } from "store/auth/auth.slice";
import _ from "lodash";
import { updateSellerId } from "store/promotionCalendar/promotionCalendar.slice";

interface TableFiltersProps {
  handleClose: () => void;
  columnsList?: string[];
  text?: string;
}

const TableFilter = ({ handleClose, columnsList, text }: TableFiltersProps) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const { columnFilters } = useSelector((state: AppState) => state.table);
  const [filterValues, setFilterValues] = useState<any[]>([]);
  const getFilterValues = (filters: any[]) => {
    setFilterValues(filters);
  };
  const selectedSellers = useSelector(
    (state: AppState) => state.auth.selectedSellers
  );
  const location = useLocation();

  const handleClickApply = () => {
    handleClose();
    const key = filterValues[0];
    const val = filterValues[1];
    if (filterValues.length) {
      if (_.isEmpty(columnFilters)) dispatch(addFilters(filterValues));
      else {
        const key = filterValues[0];
        const val = filterValues[1];
        dispatch(updateFilters(filterValues));
      }
    }
  };
  const clearFilterValues = () => {
    dispatch(clearFilters());
    dispatch(removeAllSellers());
    if (location.pathname === ROUTES.Ulysses) {
      const updatedSellers = selectedSellers.map((seller, i) => {
        return { ...seller, checked: i === 0 ? true : false };
      });
      dispatch(addSelectedSellers(updatedSellers));
    }
  };

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        position: "absolute",
        zIndex: 2,
        right: "83px",
      }}
    >
      <Paper
        elevation={2}
        sx={{
          width: "550px",
          padding: "16px",
          borderRadius: "8px",
          position: "relative",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            right: "20px",
            top: "20px",
            cursor: "pointer",
          }}
          onClick={handleClose}
        >
          <img src={CrossIcon} alt="cross" />
        </Box>
        <FormGroup>
          <Select getFilterValues={getFilterValues} />
        </FormGroup>

        <Box
          sx={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            marginTop: "25px",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Lato",
              fontStyle: "normal",
              fontWeight: 400,
              fontSize: "14px",
              color: "#rgba(13, 71, 161, 1)",
              cursor: "pointer",
            }}
            onClick={() => {
              clearFilterValues();
              handleClose();
            }}
          >
            Clear
          </Typography>

          <Button
            secondary={true}
            primary={false}
            loading={false}
            text={intl.formatMessage({
              id: I18nKey.APPLY,
            })}
            onClick={handleClickApply}
            width="50px"
            height="24px"
          />
        </Box>
      </Paper>
    </Stack>
  );
};

export default TableFilter;
